import React, {useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import Grid from '@mui/material/Grid';
import {useStylesECDS} from './ecdsStyle';
import config from '../../../../app/config';
import AgyleTextField from '../../../../components/ui/fields/agyleTextField';
import {cleanObject} from '../../../../util/patientContextUtil';

const AmbulanceDetails = (props) => {
    const {t} = useTranslation();
    const classes = useStylesECDS();

    const {isSmall} = props;

    // Ambulance Details Dataset
    const [ambulance, setAmbulance] = useState({
        AmbulanceCallIdentifier: '',
        OrganisationIdentifier_ConveyingAmbulanceTrust: '',
        CareContactIdentifier_AmbulanceService: '',
    });

    // For ReadOnly Data
    const disableData = useRef({});

    // Validation
    const validationEnabled = config?.modules?.forms?.ecds?.validation || false;
    const [error, setError] = useState({
        callId: false,
        contactId: false,
        orgId: false,
    });

    // Initial Data
    useEffect(() => {
        let data = {};
        let dataToBlock = {};

        if (props?.patient?.admission) {
            dataToBlock = {
                AmbulanceCallIdentifier: props?.patient?.admission?.ambulanceIncidentNumber || '',
                OrganisationIdentifier_ConveyingAmbulanceTrust: props?.patient?.admission?.conveyingAmbulanceOrgId || '',
                CareContactIdentifier_AmbulanceService: props?.patient?.admission?.careContactIdentifier || '',
            };
        }

        if (props.patient?.studies?.EmergencyCare?.AttendanceOccurrence?.AmbulanceDetails) {
            data = {...props.patient?.studies?.EmergencyCare?.AttendanceOccurrence?.AmbulanceDetails};
        }

        data = {
            ...dataToBlock,
            ...data,
        };

        setAmbulance(prevState => ({...prevState, ...data}));
        disableData.current = {...cleanObject(dataToBlock)};
    }, []);

    const updateData = () => {
        const data = {
            AmbulanceCallIdentifier: ambulance.AmbulanceCallIdentifier,
            OrganisationIdentifier_ConveyingAmbulanceTrust: ambulance.OrganisationIdentifier_ConveyingAmbulanceTrust,
            CareContactIdentifier_AmbulanceService: ambulance.CareContactIdentifier_AmbulanceService,
        };
        props.setData(data);
    };

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (validate()) {
                updateData();
            }
        }, 400);
        return () => clearTimeout(timeoutId);
    }, [ambulance]);

    const changeHandler = (event) => {
        setAmbulance((prevState) => ({...prevState, [event.target.name]: event.target.value}));
    };

    const validate = () => {
        let check = true;

        if (validationEnabled) {
            const errorData = {
                callId: ambulance.AmbulanceCallIdentifier !== '' ? !props.checkLenght(1, 20, ambulance.AmbulanceCallIdentifier) : false,
                contactId: ambulance.CareContactIdentifier_AmbulanceService !== '' ? !props.checkLenght(1, 20, ambulance.CareContactIdentifier_AmbulanceService) : false,
                orgId: ambulance.OrganisationIdentifier_ConveyingAmbulanceTrust !== '' ? !props.checkLenght(3, 5, ambulance.OrganisationIdentifier_ConveyingAmbulanceTrust) : false,
            };
            setError(prevState => ({...prevState, ...errorData}));

            for (let prop in errorData) {
                if (errorData[prop]) {
                    check = false;
                    break;
                }
            }

            if (props.valid) {
                const validObj = {
                    name: 'Ambulance Details',
                    groupStatus: 'R',
                    mandatory: false,
                    errors: !check,
                    pickers: false,
                };
                props.valid(prevState => ({...prevState, 'ambulance': validObj}));
            }
        }
        return check;
    };

    if (props.accordion !== 'Ambulance Details') return null;

    return (
        <div className={classes.root}>
            <Grid container spacing={2} style={{marginTop: 1}}>
                <Grid item xs={isSmall ? 12 : 4}>
                    <AgyleTextField
                        name="AmbulanceCallIdentifier"
                        label={t('Ambulance Call Identifier')}
                        onChange={changeHandler}
                        value={ambulance.AmbulanceCallIdentifier || ''}
                        error={error.callId}
                        helperText={error.callId ? 'Input must be max 20 characters long.' : ''}
                        maxLength={20}
                        readOnly={!!disableData?.current.AmbulanceCallIdentifier}
                        fullWidth
                        debounce
                        noBorder={false}
                        withNewBackground
                        size="large"
                    />
                </Grid>

                <Grid item xs={isSmall ? 12 : 4}>
                    <AgyleTextField
                        name="CareContactIdentifier_AmbulanceService"
                        label={t('Care Contact Identifier')}
                        onChange={changeHandler}
                        value={ambulance.CareContactIdentifier_AmbulanceService || ''}
                        error={error.contactId}
                        helperText={error.contactId ? 'Input must be max 20 characters long.' : ''}
                        maxLength={20}
                        readOnly={!!disableData?.current.CareContactIdentifier_AmbulanceService}
                        fullWidth
                        debounce
                        noBorder={false}
                        withNewBackground
                        size="large"
                    />
                </Grid>

                <Grid item xs={isSmall ? 12 : 4}>
                    <AgyleTextField
                        name="OrganisationIdentifier_ConveyingAmbulanceTrust"
                        label={t('Org Id - Conveying Ambulance Trust')}
                        onChange={changeHandler}
                        value={ambulance.OrganisationIdentifier_ConveyingAmbulanceTrust || ''}
                        error={error.orgId}
                        helperText={error.orgId ? 'Input must be between 3 and 5 characters long.' : ''}
                        maxLength={5}
                        minLength={3}
                        readOnly={!!disableData?.current.OrganisationIdentifier_ConveyingAmbulanceTrust}
                        fullWidth
                        debounce
                        noBorder={false}
                        withNewBackground
                        size="large"
                    />
                </Grid>
            </Grid>
        </div>
    );
};

export default AmbulanceDetails;
